import React from 'react'

import { useNavigate } from 'react-router-dom'

import { MenuItem } from '@/components'
import { RoutesNames } from '@/routes/routes'
import { requestAnalytics } from '@/services/bridge'

import * as S from './styles'

export const PartnerProducts = ({
  title,
  description,
  options,
}: DeclarationFacilitatedMetadataPartnerProducts) => {
  const navigate = useNavigate()

  const handleNavigate = (url: string) => {
    navigate(url)
  }

  return (
    <S.Container>
      <S.Text variant="headline-h3" semiBold colorWeight={500}>
        {title}
      </S.Text>

      <S.Space />

      <S.Text variant="body-3">{description}</S.Text>

      <S.Space />

      <S.PartnerSectionContainer>
        {options.includes('CONSORTIUM') && (
          <MenuItem
            title="Consórcio"
            onClick={() => {
              handleNavigate(RoutesNames.CONSORTIUM)
              requestAnalytics('AcessoProdParcConsorcio')
            }}
          />
        )}
        {options.includes('PENSION') && (
          <MenuItem
            title="Previdência"
            onClick={() => {
              handleNavigate(RoutesNames.PENSION)
              requestAnalytics('AcessoProdParcPrevidencia')
            }}
          />
        )}
      </S.PartnerSectionContainer>
    </S.Container>
  )
}
